export const env = {
  API_URL: process.env.NEXT_PUBLIC_API_URL!,
  CSRF_KEY: process.env.NEXT_PUBLIC_CSRF_KEY!,
  JWT_SECRET: process.env.NEXT_PUBLIC_JWT_SECRET!,
};